import { useRepositories } from '../../../contexts';
import { InvalidationTag, LoaderType, useAppQuery } from '../utils';
import { useLanguage } from '../../../locale';
export var useGetFromWorld = function (loaderType) {
    if (loaderType === void 0) { loaderType = LoaderType.FullPage; }
    var _a = useLanguage(), locale = _a[2];
    var filtersRepo = useRepositories().filtersRepo;
    var getFromWorldQuery = useAppQuery([InvalidationTag.FromWorld, locale], filtersRepo.getFromWorld, {}, loaderType);
    return getFromWorldQuery;
};
